// Manual order within a day or a tray group, on one fractional `order` field.
// A reorder writes one document; only when the gaps get too small is a list
// renumbered.

import type { Task } from '@/types'

/** A value that sorts between two neighbours, or at an end. */
export function orderBetween(prev: number | null | undefined, next: number | null | undefined): number {
  if (prev == null && next == null) return 0
  if (prev == null) return next! - 1
  if (next == null) return prev + 1
  return (prev + next) / 2
}

/** True when neighbouring orders are too close to halve safely. */
export function needsRenumber(sorted: Task[]): boolean {
  for (let i = 1; i < sorted.length; i += 1) if (Math.abs(sorted[i].order - sorted[i - 1].order) < 1e-6) return true
  return false
}

/** Fresh whole-number orders for a list, keeping its sequence. */
export function renumber(sorted: Task[]): { id: string; order: number }[] {
  return sorted.map((t, i) => ({ id: t.id, order: i }))
}

/**
 * Where a card lands when dropped at `index` in `column` (the list's untimed
 * open tasks in order, without the moving card). Returns the one order to write.
 */
export function orderAt(column: Task[], index: number): number {
  const i = Math.max(0, Math.min(index, column.length))
  const prev = i > 0 ? column[i - 1].order : null
  const next = i < column.length ? column[i].order : null
  return orderBetween(prev, next)
}
